import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const useColors = {
  background: '#F1F9FF',
  palette: {
    secondary: {
      main: '#F1F9FF',
      secondary: '#BCE0FD',
    },
    primary: {
      main: '#AF4700',
    },
  },
  buttons: {
    primary: '#AF4700',
    secondary: '#F79D61',
  },
};

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarColor: '#AF4700',
          '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            background: 'linear-gradient(0deg, rgba(175,71,0,0) 0%, rgba(255,215,191,1) 50%, rgba(0,212,255,0) 100%);',
            width: 8,
            height: 8,
          },
          '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            borderRadius: 16,
            backgroundColor: '#AF4700',
            minHeight: 16,
            border: '3px solid #AF4700',
          },
          '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
            backgroundColor: '#AF4700',
          },
          '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
            backgroundColor: '#AF4700',
          },
          '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#AF4700',
          },
          '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
            backgroundColor: '#AF4700',
          },
        },
      },
    },
    MuiList: {
      variants: [
        {
          props: { variant: 'sectionList' },
          style: {
            borderRadius: '10px',
            backgroundColor: 'white',
            color: '#AF4700',
            padding: '0px',
            overflow: 'auto',
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 1px 4px',
            maxHeight: '60vh',
            '& .MuiButtonBase-root:hover': {
              backgroundColor: '#FBD7BF',
            },
          },
        },
        {
          props: { variant: 'establishmentSectionList' },
          style: {
            borderRadius: '10px',
            backgroundColor: 'white',
            color: '#AF4700',
            padding: '0px',
            overflow: 'auto',
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 1px 4px',
            maxHeight: '50vh',
            '& .MuiButtonBase-root:hover': {
              backgroundColor: '#FBD7BF',
            },
          },
        },
        {
          props: { variant: 'sidebarList' },
          style: {
            width: '100%',
            maxWidth: 220,
            backgroundColor: '#AF4700',
            height: '100vh',
            overflowY: 'auto',
            color: useColors.palette.primary.main,
            borderRight: `3px solid ${useColors.palette.secondary.secondary}`,
            '& .MuiButtonBase-root:hover': {
              backgroundColor: '#FBD7BF',
            },
          },
        },
      ],
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            color: 'white',
            '& :hover': {
              backgroundColor: '#FBD7BF',
            },
          },
        },
        {
          props: { variant: 'addFloatButton' },
          style: {
            borderRadius: '3px',
            border: `2px solid ${useColors.buttons.primary}`,
            color: useColors.buttons.primary,
            position: 'absolute',
            bottom: '50px',
            right: '40px',
            '& :hover': {
              backgroundColor: '#FBD7BF',
            },
          },
        },
        {
          props: { variant: 'primaryButton' },
          style: {
            borderRadius: '3px',
            border: 'none',
            backgroundColor: useColors.buttons.primary,
            color: 'white',
            '& :hover': {
              backgroundColor: '#FBD7BF',
            },
          },
        },
        {
          props: { variant: 'secondaryButton' },
          style: {
            borderRadius: '3px',
            border: 'none',
            backgroundColor: useColors.buttons.secondary,
            color: useColors.buttons.primary,
            '& :hover': {
              backgroundColor: '#FBD7BF',
            },
          },
        },
      ],
    },
  },
  background: '#FAF7F7',
  typography: {
    bodyTitle: {
      fontWeight: 700,
    },
    h5: {
      color: '#AF4700',
    },
  },
  palette: {
    primary: {
      main: '#AF4700',
      light: '#FBD7BF',
      dark: '#AF4700',
    },
    secondary: {
      main: '#BCE0FD',
    },
    decoration: {
      main: '#F79D61',
    },
    error: {
      main: red.A400,
      light: red[100],
    },
    buttons: {
      primary: '#AF4700',
      secondary: '#FBD7BF',
    },
  },
});

export default theme;
